//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  name: "mobile",
  data() {
    return {
      keys: [],
      title: "",
      copyright: "",
      radio: "",
      source: [],
      msg: [],
      isShow: false,
      ok: false,
      pageShow: false,
      pageNum: 1,
      sliceAllMsg: []
    };
  },
  mounted() {
    this.showDetail();
  },
  methods: {
    getScrollTop() {
      let scrollPos;
      if (window.pageYOffset) {
        scrollPos = window.pageYOffset;
      } else if (document.compatMode && document.compatMode != "BackCompat") {
        scrollPos = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollPos = document.body.scrollTop;
      }
      return scrollPos;
    },
    toTop() {
      let e = this.getScrollTop();
      let setIn = setInterval(() => {
        if (e <= 1) {
          clearInterval(setIn);
        } else {
          e -= 20;
          window.scrollTo(0, e);
        }
      }, 3);
    },
    back() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.msg = this.sliceAllMsg[this.pageNum - 1];
        this.toTop();
      } else {
        this.$vux.toast.text("已经到顶啦~", "middle");
      }
    },
    next() {
      if (this.pageNum < this.sliceAllMsg.length) {
        this.pageNum++;
        this.msg = this.sliceAllMsg[this.pageNum - 1];
        this.toTop();
      } else {
        this.$vux.toast.text("已经到底啦~", "middle");
      }
    },
    showDetail() {
      const loading = this.$vux.loading;
      loading.show({
        text: "加载中"
      });
      let formTmp = new FormData();
      formTmp.append("type", "getMsg");
      formTmp.append("time", this.$route.params.id);
      axios.post(this.$apiUrl, formTmp).then(data => {
        loading.hide();
        this.ok = true;
        // console.log(data.data);
        if (data.data.success == true) {
          this.keys = data.data.msg.keys;
          this.title = data.data.msg.title;
          this.copyright = data.data.msg.copyright;
          this.radio = data.data.msg.radio;
          document.title = this.copyright + " - " + this.title;
          this.source = data.data.msg.source;
        }
      });
    },
    sliceArr(array, size) {
      let result = [];
      for (var x = 0; x < Math.ceil(array.length / size); x++) {
        let start = x * size;
        let end = start + size;
        result.push(array.slice(start, end));
      }
      return result;
    },
    checkMsg() {
      const loading = this.$vux.loading;
      loading.show({
        text: "查询中"
      });
      this.msg = [];
      let allMsg = [];
      let formTmp = [];
      let isFull = 0;
      this.pageShow = false;
      this.pageNum = 1;
      this.sliceAllMsg = [];

      for (let index in this.keys) {
        if (
          this.keys[index].type == true &&
          this.keys[index].value !== undefined &&
          this.keys[index].value != ""
        ) {
          isFull++;
        }
      }

      for (let index in this.keys) {
        if (this.keys[index].type == true) {
          formTmp.push({
            name: this.keys[index].name,
            value: this.keys[index].value
          });
        }
      }

      if (isFull != formTmp.length) {
        this.$vux.toast.text("输入不可为空", "middle");
      } else {
        for (let index in formTmp) {
          if (formTmp.value == "" || formTmp.value == undefined) {
            isFull = false;
          }
        }

        if (this.radio == "0") {
          // 模糊查询
          for (let i = 0; i < this.source.length; i++) {
            let type = true;
            for (let j = 0; j < formTmp.length; j++) {
              if (
                this.source[i][formTmp[j].name].indexOf(formTmp[j].value) == -1
              ) {
                type = false;
              }
            }
            if (type == true) {
              allMsg.push(this.source[i]);
            }
          }
        } else if (this.radio == "1") {
          // 精确查询
          for (let i = 0; i < this.source.length; i++) {
            let type = true;
            for (let j = 0; j < formTmp.length; j++) {
              if (this.source[i][formTmp[j].name] != formTmp[j].value) {
                type = false;
              }
            }
            if (type == true) {
              allMsg.push(this.source[i]);
            }
          }
        } else {
          // 默认为模糊查询
          for (let i = 0; i < this.source.length; i++) {
            let type = true;
            for (let j = 0; j < formTmp.length; j++) {
              if (
                this.source[i][formTmp[j].name].indexOf(formTmp[j].value) == -1
              ) {
                type = false;
              }
            }
            if (type == true) {
              allMsg.push(this.source[i]);
            }
          }
        }
      }
      loading.hide();
      if (allMsg.length == 0) {
        this.isShow = true;
        this.$vux.toast.text("搜索结果为空", "middle");
        return;
      }
      let sliceAllMsg = this.sliceArr(allMsg, 10);
      this.sliceAllMsg = sliceAllMsg;
      if (sliceAllMsg.length > 1) {
        this.pageShow = true;
      } else {
        this.pageShow = false;
      }
      this.msg = this.sliceAllMsg[this.pageNum - 1];
      this.$vux.toast.text("共为您搜索到" + allMsg.length + "条信息", "middle");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mobile.vue